module.exports = __webpack_public_path__ + "img/vector-error.fb1db71a.png";